exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".x-loading[data-v-7d782543]{z-index:1200}.x-loading[data-v-7d782543] .content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:rgba(0,0,0,.6);-webkit-box-shadow:none;box-shadow:none;border:0;height:26.66667vw;border-radius:1.6vw}.x-loading[data-v-7d782543] .dialog{background-color:transparent;width:26.66667vw;margin-top:-20vw}", ""]);

// exports
